import script from "./FileUploader2.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileUploader2.vue?vue&type=script&setup=true&lang=ts"

import "./FileUploader2.vue?vue&type=style&index=0&id=2c884931&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c884931"]])

export default __exports__